var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39,
    cy: 39,
    r: 39,
    fill: "url(#paint0_linear_1_2281)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9718 54.6001H28.0277C26.8015 54.5968 25.6264 54.1081 24.7592 53.2408C23.8919 52.3735 23.4032 51.1985 23.3999 49.9723V28.0282C23.4032 26.8017 23.8919 25.6267 24.7592 24.7594C25.6264 23.8924 26.8015 23.4037 28.0277 23.4001H49.9718C51.1983 23.4037 52.3733 23.8924 53.2406 24.7594C54.1075 25.6267 54.5962 26.8017 54.5999 28.0282V49.9723C54.5963 51.1985 54.1076 52.3735 53.2406 53.2408C52.3733 54.108 51.1983 54.5967 49.9718 54.6001ZM51.9999 28.0286C51.9999 27.4907 51.786 26.9748 51.406 26.5944C51.0256 26.2143 50.5097 26.0004 49.9717 26.0004H28.0276C27.4898 26.0004 26.9741 26.2143 26.5937 26.5944C26.2133 26.9747 25.9997 27.4907 25.9997 28.0286V49.9727C25.9997 50.5105 26.2133 51.0262 26.5937 51.4066C26.9741 51.787 27.4898 52.0006 28.0276 52.0006H49.9717C50.5096 52.0006 51.0256 51.787 51.406 51.4066C51.786 51.0263 51.9999 50.5105 51.9999 49.9727V28.0286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1133 45.6877C38.0448 45.6877 36.0609 44.866 34.5981 43.403C33.1351 41.9403 32.3134 39.9564 32.3134 37.8879C32.3134 35.8191 33.1351 33.8352 34.5981 32.3725C36.0609 30.9097 38.0447 30.0877 40.1133 30.0877C42.182 30.0877 44.1659 30.9097 45.6287 32.3725C47.0914 33.8352 47.9134 35.819 47.9134 37.8879C47.9134 39.9564 47.0914 41.9403 45.6287 43.403C44.1659 44.866 42.1821 45.6877 40.1133 45.6877ZM40.1133 32.6883C38.7341 32.6883 37.4117 33.2359 36.4364 34.2112C35.4613 35.1863 34.9134 36.5091 34.9134 37.8881C34.9134 39.2672 35.4613 40.5897 36.4364 41.565C37.4117 42.5401 38.7342 43.088 40.1133 43.088C41.4923 43.088 42.8151 42.5401 43.7902 41.565C44.7655 40.5897 45.3131 39.2672 45.3131 37.8881C45.3131 36.5091 44.7655 35.1863 43.7902 34.2112C42.8151 33.2359 41.4923 32.6883 40.1133 32.6883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1431 47.9146C50.1431 46.6838 49.1452 45.6859 47.9144 45.6859C46.6836 45.6859 45.686 46.6838 45.686 47.9146C45.686 49.1452 46.6836 50.1431 47.9144 50.1431C49.1452 50.1431 50.1431 49.1452 50.1431 47.9146Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2281",
    x1: -5.98413,
    y1: 78,
    x2: 85.2222,
    y2: 11.5556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E5CEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DD6FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.2,
    height: 31.2,
    fill: "white",
    transform: "matrix(1 0 0 -1 23.3998 54.6001)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.fe27d5a83d22c85cf7ebbffee0ba3212.svg";
export { ForwardRef as ReactComponent };